<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <v-snackbar
      v-if="updateFile.color != undefined"
      v-model="updateFile.show"
      :color="updateFile.color"
      :top="true"
      :multi-line="true"
      :right="true"
      :timeout="5000"
      :vertical="true"
    >
      {{ updateFile.msj }}
      <v-btn color="white" text @click="closeSnack">Cerrar</v-btn>
    </v-snackbar>
    <v-footer id="main-menu-app" v-show="login" height="56px" :fixed="fixed" app>
      <v-card height="56px" width="100%" text>
        <v-bottom-navigation :value="true" v-model="e1" absolute>
          <!-- <img class="footer-bg" src="@/assets/bg-bar.png" alt /> -->
          <v-btn to="/home" text value="home">
            <!-- <v-icon>flaticon-bell-3</v-icon> -->
            <v-icon>flaticon-house</v-icon>
          </v-btn>
          <!-- <v-btn to="/courier" text value="Package">
            <v-icon>flaticon-package</v-icon>
          </v-btn>-->

          <!-- <v-btn to="/home" text value="home">
          <v-icon>flaticon-bell-3</v-icon>-->
          <!-- <v-icon>flaticon-house</v-icon> -->
          <!-- </v-btn> -->

          <v-btn to="/prealert" text value="Prealert">
            <v-icon>flaticon-delivery</v-icon>
          </v-btn>

          <!-- <v-btn v-if="showDelivery == true" to="/delivery" text value="Delivery">
            <v-icon>flaticon-food</v-icon>
          </v-btn>-->
          <!-- <v-btn to="/delivery" text value="Delivery">
            <v-icon>flaticon-food</v-icon>
          </v-btn>-->

          <!-- <v-btn to="/notification" flat value="chats">
           <v-icon>flaticon-bell-3</v-icon>
          </v-btn>-->

          <v-btn to="/message">
            <v-icon>flaticon-speech-bubble</v-icon>
          </v-btn>

          <v-btn to="/office" text value="Office">
            <v-icon>flaticon-shop</v-icon>
          </v-btn>

          <v-btn to="/profile" text value="Profile">
            <v-icon>flaticon-user</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
// import Helpers from "./utils/helpers";
import Server from "./utils/server";
export default {
  created() {
    this.getPacks();
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            this.getPacks();
          }
        }
      }
    );
    this.$store.watch(
      (state, getters) => getters.profile,
      // (newValue, oldValue) => {
      () => {
        this.showDeliveryFc();
      }
    );
  },
  mounted() {

    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }else{
      this.currentUser = {
        userName: null,
        pushId:null
      };
      this.getPacks();
    }
  },
  data() {
    return {
      e1: "packages",
      clipped: false,
      drawer: false,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      currentUser: undefined,
      showDelivery: false,
      items: [
        {
          icon: "bubble_chart",
          title: "Inspire",
        },
      ],
    };
  },
  methods: {
    closeSnack() {
      this.$store.dispatch("showUploadFile", false);
    },
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },
    getPacks() {
      if(this.currentUser == undefined){
        this.currentUser = {
        userName: null,
        pushId:null
      };
      }
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$store.dispatch("getProfile", {
        Vue: this,
        url: Server.profile,
        data: formData,
      });
      this.showDeliveryFc();
    },
    showDeliveryFc() {
      if (this.profile.length > 0) {
        if (
          this.profile[0].domicilio != "" &&
          this.profile[0].domicilio != 0 &&
          this.profile[0].domicilio != "0" &&
          this.profile[0].domicilio != undefined
        ) {
          this.showDelivery = true;
        } else {
          this.showDelivery = false;
        }
      } else {
        this.showDelivery = false;
      }
    },
  },
  computed: {
    login: function () {
      return this.$store.getters.login;
    },
    user: function () {
      return this.$store.getters.user;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
    updateFile() {
      return this.$store.getters.updateFile;
    },
  },
  name: "App",
};
</script>

<style lang="scss">
@import "./assets/flaticon/flaticon.scss";
@import "./assets/css/style.scss";
</style>
